import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { WebsiteBuilderSidebarPresentation } from './website-builder-sidebar.presentation';
import { WebsiteBuilderSidebarVM } from './website-builder-sidebar.viewmodel';
import { HubPreviewRefreshCallback } from '../_content/_hub-embed/hub-preview-sync.types';

type WebsiteBuilderSidebarProps = {
    versionId: number;
    accountId: number;
    eventHubId: number;
    onHubPreviewRefresh?: HubPreviewRefreshCallback;
};

export const WebsiteBuilderSidebar = withViewModel<WebsiteBuilderSidebarProps, WebsiteBuilderSidebarVM>(
    WebsiteBuilderSidebarPresentation,
    props => new WebsiteBuilderSidebarVM(
        props.versionId,
        props.accountId,
        props.eventHubId,
        props.onHubPreviewRefresh,
    ),
    props => [props.versionId, props.accountId, props.eventHubId],
    vm => vm.dispose(),
);
